module.exports = __webpack_public_path__ + "static/media/aff.2edc7247.png";